/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 09:41:54
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
import EnumMalfunctionAuditStatus from 'src/enums/enumMalfunctionAuditStatus';

export namespace BatchAuditVOI {
    export interface PropsI {
        api: Function;
        ids: number[];
        isSubmit?: boolean;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        status: number;
        refuse_cause: string;
    }
}

@Component
class BatchAuditModal extends Vue.Component<BatchAuditVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Array,
    })
    ids!: number[];

    @Prop({
        type: Boolean,
    })
    isSubmit!: boolean;

    @Prop({
        type: Function,
    })
    api!: Function;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: BatchAuditVOI.FormDataI = {
        status: !this.isSubmit?1:0,
        refuse_cause: '',
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!this.isSubmit && this.formData.status === EnumMaintenanceAuditStatus.Reject.getId() && !this.formData.refuse_cause) {
            return Toast.error('请填写审核不通过原因');
        }
        if (this.isSubmit && this.formData.status === EnumMalfunctionAuditStatus.不提交.getId() && !this.formData.refuse_cause) {
            return Toast.error('请填写审核不通过原因');
        }
        this.loading = true;
        let params:any
        if(this.isSubmit) {
            params = {
                ids: this.ids,
                status: this.formData.status,
                nosubmit_cause: this.formData.status === EnumMalfunctionAuditStatus.不提交.getId() ? this.formData.refuse_cause : '',
            }
        } else {
            params = {
                ids: this.ids,
                status: this.formData.status,
                refuse_cause: this.formData.status === EnumMaintenanceAuditStatus.Reject.getId() ? this.formData.refuse_cause : '',
            }
        }
        let res = await this.api(params);
        this.loading = false;
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success('操作成功！');
            this.saveSuccess();
            this.closeModal();
        }
    }

    render(h) {
        return (
            <Modal title="批量审核" width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules} v-if={!this.isSubmit}>
                    <form-item label="" labelWidth={20} style="display: inline-block;width:90%">
                        <radio-group v-model={this.formData.status}>
                            <radio label={EnumMaintenanceAuditStatus.Audited.getId()}>{EnumMaintenanceAuditStatus.Audited.getName()}</radio>
                            <radio label={EnumMaintenanceAuditStatus.Reject.getId()}>{EnumMaintenanceAuditStatus.Reject.getName()}</radio>
                        </radio-group>
                    </form-item>
                    <form-item
                        labelWidth={20}
                        v-if={this.formData.status === EnumMaintenanceAuditStatus.Reject.getId()}
                        label=""
                        style="display: inline-block;width:90%"
                        prop="refuse_cause"
                    >
                        <Input placeholder="请输入原因" v-model={this.formData.refuse_cause} type="textarea" />
                    </form-item>
                </i-form>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules} v-else>
                    <form-item label="" labelWidth={20} style="display: inline-block;width:90%">
                        <radio-group v-model={this.formData.status}>
                            <radio label={0}>提交</radio>
                            <radio label={EnumMalfunctionAuditStatus.不提交.getId()}>
                                {EnumMalfunctionAuditStatus.不提交.getName()}
                            </radio>
                        </radio-group>
                    </form-item>
                    <form-item
                        labelWidth={20}
                        v-if={this.formData.status === EnumMalfunctionAuditStatus.不提交.getId()}
                        label=""
                        style="display: inline-block;width:90%"
                        prop="refuse_cause"
                    >
                        <Input placeholder="请输入原因" v-model={this.formData.refuse_cause} type="textarea" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertBatchAuditModal(ids: number[], api: Function, isSubmit?: boolean): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<BatchAuditVOI.PropsI>(BatchAuditModal)({
            ids,
            api,
            isSubmit,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
